import Flex from 'components/common/Flex';
import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { createPortal } from 'react-dom';

const Loading = ({ message = 'Carregando...' }) => {
  useEffect(() => {
    // Injeta estilo global no head para garantir máxima prioridade
    const styleId = 'loading-overlay-global-style';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .loading-overlay {
          z-index: 9999999 !important;
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      // Remove o estilo quando o componente for desmontado
      const style = document.getElementById(styleId);
      if (style) {
        style.remove();
      }
    };
  }, []);

  return createPortal(
    <div
      style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
      onClick={e => e.stopPropagation()}
      className="loading-overlay"
    >
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="text-center"
        style={{
          animation: 'fadeIn 0.3s ease-in-out',
          gap: '1.5rem'
        }}
      >
        <div
          className="bg-body"
          style={{
            borderRadius: '20px',
            padding: '2.5rem',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
            minWidth: '280px',
            animation: 'scaleIn 0.4s ease-in-out'
          }}
        >
          <Spinner
            animation="border"
            style={{
              width: 80,
              height: 80,
              borderWidth: '6px'
            }}
            variant="primary"
          />
          {message && (
            <div
              className="mt-3 fw-semibold text-body-emphasis"
              style={{
                fontSize: '1.1rem',
                letterSpacing: '0.5px'
              }}
            >
              {message}
            </div>
          )}
        </div>
      </Flex>
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          @keyframes scaleIn {
            from {
              transform: scale(0.8);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>,
    document.body
  );
};

export default Loading;
